export const setAuthSession = (data: {
  access_token: string;
  refresh_token: string;
}) => {
  localStorage.setItem("mun-auth-token", data.access_token);
  localStorage.setItem("mun-auth-rtoken", data.refresh_token);
};

export const clearAuthSession = () => {
  localStorage.removeItem("mun-auth-token");
  localStorage.removeItem("mun-auth-rtoken");
};

export const getAuthToken = () => {
  return localStorage.getItem("mun-auth-token");
};

export const getRefreshToken = () => {
  return localStorage.getItem("mun-auth-rtoken");
};
